// @flow
import take from 'lodash/take';
import get from 'lodash/get';
import values from 'lodash/values';
import concat from 'lodash/concat';

type SolJobMetadata = *;
type ObjectWithSolJobMetadata = { solMetadata: SolJobMetadata };
type SolJobMetadataKey = {
  searchRequestToken: string,
  jobId: string
};

const defaultSizeLimit = 100;
const localStorageKey = 'sol';

const getKey = jobMetadata =>
  `${get(jobMetadata, 'jobId')}_${get(jobMetadata, 'searchRequestToken')}`;

const mapSolMetadata = (
  jobMetadataArray: Array<ObjectWithSolJobMetadata>
): Array<SolJobMetadata> =>
  jobMetadataArray.map(({ solMetadata }) => solMetadata);

const compareEventTime = (jobMetadataA, jobMetadataB) =>
  new Date(get(jobMetadataB, 'eventTime')) -
  new Date(get(jobMetadataA, 'eventTime'));

const concatSortTake = (newArray, existingArray, sizeLimit) =>
  take(concat(newArray, existingArray).sort(compareEventTime), sizeLimit);

const mergeKeysToMetadata = (
  newArray: Array<SolJobMetadata>,
  existingArray: Array<SolJobMetadata>,
  sizeLimit: number
): Object =>
  concatSortTake(newArray, existingArray, sizeLimit).reduce(
    (accumulator, jobMetadata) => {
      accumulator[getKey(jobMetadata)] = jobMetadata;
      return accumulator;
    },
    {}
  );

const getAllKeysToMetadata = (storage: Storage = window.localStorage) =>
  JSON.parse(storage.getItem(localStorageKey) || '{}');

export const addJobDetailsMetadata = (
  arr: Array<ObjectWithSolJobMetadata>,
  storage: Storage = window.localStorage,
  sizeLimit: number = defaultSizeLimit
) => {
  const preExistingKeys = values(getAllKeysToMetadata(storage));
  const mergedKeysToMetadata = mergeKeysToMetadata(
    mapSolMetadata(arr),
    preExistingKeys,
    sizeLimit
  );

  storage.setItem(localStorageKey, JSON.stringify(mergedKeysToMetadata));
};

export const getDefaultMetadata = (jobId: string) => ({
  searchRequestToken: '00000000-0000-4000-8000-000000000000',
  jobId,
  jobAdType: 'ORGANIC',
  section: 'MAIN',
  sectionRank: 1
});

export const getJobDetailsMetadata = (
  { searchRequestToken, jobId }: SolJobMetadataKey,
  storage: Storage = window.localStorage
): ?SolJobMetadata => {
  const key = `${jobId}_${searchRequestToken}`;
  return getAllKeysToMetadata(storage)[key] || getDefaultMetadata(`${jobId}`);
};
